import type * as React from "react";

import { cn } from "@/lib/utils";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex min-h-20 w-full min-w-0 rounded-lg border bg-transparent px-4 py-3 text-base shadow-xs transition-[color,box-shadow,opacity,transform] outline-none resize-none disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-base",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] [&[data-slot='textarea']]:focus-visible:ring-0 [&[data-slot='textarea']]:focus-visible:border-gray-400",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        "placeholder:transition-[opacity,transform] placeholder:duration-300 placeholder:ease-out",
        "focus:placeholder:opacity-0 focus:placeholder:-translate-x-2",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
